import { render, staticRenderFns } from "./ConfirmSuccess.vue?vue&type=template&id=6f8156f0&scoped=true&"
import script from "./ConfirmSuccess.vue?vue&type=script&lang=js&"
export * from "./ConfirmSuccess.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/frontend/home.scss?vue&type=style&index=0&id=6f8156f0&lang=scss&scoped=true&"
import style1 from "@/assets/scss/frontend/content.scss?vue&type=style&index=1&id=6f8156f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8156f0",
  null
  
)

export default component.exports